var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgMessageCircle = _a => {
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size || 24,
    height: size || 24,
    viewBox: "0 0 24 24",
    role: props.role,
    "aria-hidden": props['aria-hidden'] || true
  }, props), React.createElement("path", {
    fill: props.color || 'currentColor',
    fillRule: "evenodd",
    d: "M20.7708784,15.6353225 C19.2048634,18.7687087 16.003219,20.748673 12.5019554,20.7500259 C11.170068,20.7534985 9.85486501,20.4655356 8.64815212,19.9078805 L3.23717082,21.711541 C2.6508523,21.9069805 2.09304802,21.3491762 2.28848753,20.7628577 L4.09214783,15.3518768 C3.53449285,14.1451723 3.24652977,12.8300832 3.25000006,11.4997383 C3.25135552,7.99680952 5.23131982,4.79516511 8.36185998,3.23057996 C9.64541532,2.58225315 11.063961,2.2462818 12.5,2.24999749 L13.0413141,2.25116725 C17.7388283,2.51032529 21.4897032,6.26120016 21.7500285,11.0000285 L21.7500285,11.4990722 C21.7535911,12.9367242 21.4176256,14.3549096 20.7708784,15.6353225 Z M8.46282918,18.388516 C8.65253857,18.3252795 8.85964607,18.3404222 9.03814002,18.43058 C10.1108155,18.9723909 11.2963033,19.2531643 12.4997098,19.2500285 C15.434596,19.2488929 18.1170549,17.5900039 19.4305515,14.9618885 C19.9723624,13.889213 20.2531358,12.7037252 20.2500025,11.5019839 L20.2511388,11.0413426 C20.0340974,7.10723797 16.8927905,3.96593107 13,3.75 L12.4980446,3.75 C11.2963033,3.74689267 10.1108155,4.02766611 9.03529406,4.57090694 C6.41002461,5.88297361 4.7511356,8.56543244 4.74999745,11.5019839 C4.74686419,12.7037252 5.02763762,13.889213 5.56944852,14.9618885 C5.65960624,15.1403824 5.67474894,15.3474899 5.61151247,15.5371993 L4.18585412,19.8141744 L8.46282918,18.388516 Z"
  }));
};
export default SvgMessageCircle;